import React from 'react'
import DeleteIcon from '@mui/icons-material/Delete'
import { client } from '../../utils/client'
import { useDispatch } from 'react-redux'
import { setLoading, showSnackbar } from '../../actions/pageActions'
import { IconButton } from '@mui/material'
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog'
import { PATIENTS_PATH } from '../../constants/endpointsConstants'

const DeletePatient = ({ patient, onDelete }) => {
  const dispatch = useDispatch()

  const deletePatient = () => {
    dispatch(setLoading(true))
    client
      .delete(`${PATIENTS_PATH}/${patient.id}`)
      .then(resp => {
        dispatch(setLoading(false))
        dispatch(showSnackbar(resp.data.message, 'success'))
        onDelete(patient.id)
      })
      .catch(() => {
        dispatch(setLoading(false))
        dispatch(showSnackbar())
      })
  }
  return (
    <ConfirmDialog
      buttonOpen={
        <IconButton color="error">
          <DeleteIcon />
        </IconButton>
      }
      title="Eliminar paciente"
      body={`¿Deseas eliminar a "${patient.name} ${patient.lastNameFather} ${patient.lastNameMother}"?`}
      onConfirm={deletePatient}
    />
  )
}

export default DeletePatient
